import script from "./TriggerBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./TriggerBox.vue?vue&type=script&lang=ts&setup=true"

import "./TriggerBox.vue?vue&type=style&index=0&id=cabb7274&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cabb7274"]])

export default __exports__